export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14144.638f8b2f.jpg";